// base
import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";

// assets
import "./header.scss";
import { header_logo } from "../../assets/images/header";
import Dropdown from "../Dropdown";
import {
  Container,
  DropdownButton,
  Nav,
  Navbar,
  NavDropdown,
} from "react-bootstrap";
const dropdown = false;
const Header = (props) => {
  const [dropdown, setDropdown] = useState(false);
  const [dropdown1, setDropdown1] = useState(false);
  const onMouseEnter = (temp) => {
    if (temp === 1) {
      window.innerWidth > 960 && setDropdown(true);
    } else if (temp === 2) {
      window.innerWidth > 960 && setDropdown1(true);
    }
  };
  const onMouseLeave = (temp) => {
    if (temp === 1) {
      window.innerWidth > 960 && setDropdown(false);
    } else if (temp === 2) {
      window.innerWidth > 960 && setDropdown1(false);
    }
  };

  return (
    <header className={"Header"}>
      <div className="l-wrapper">
        <div className="header-left">
          <Link className="logo-wrapper" to="/">
            <img className="logo" src={header_logo} alt="andus logo" />
          </Link>
          <nav className="gnb">
            {/* 블록 버튼 주석 */}
            {/* <NavItem link="/blocks/1" title="Blocks" /> */}
            {/* 트랜젝션 버튼 주석 */}
            {/* <NavItem link="/transactions/1" title="Transactions"/> */}
          </nav>
        </div>

        {/* <div>
          <Navbar variant="dark" className="dropdown">
            <Nav>
              <Nav.Link className="dropdown-content-link" as={Link} to="/">
                Home
              </Nav.Link>
              <div
                onMouseEnter={() => onMouseEnter(1)}
                onMouseLeave={() => onMouseLeave(1)}
              >
                <NavDropdown
                  title="BlockChain"
                  // menuVariant="dark"
                  className="dropdown"
                  show={dropdown ? true : false}
                >
                  <NavDropdown.Item
                    className="dropdown-content"
                    as={Link}
                    to="/blocks"
                  >
                    Blocks
                  </NavDropdown.Item>
                  <NavDropdown.Divider></NavDropdown.Divider>
                  <NavDropdown.Item
                    className="dropdown-content"
                    as={Link}
                    to="/transactionList"
                  >
                    Transactions
                  </NavDropdown.Item>
                  <NavDropdown.Divider></NavDropdown.Divider>
                  <NavDropdown.Item
                    className="dropdown-content"
                    as={Link}
                    to="/ranking"
                  >
                    Accounts
                  </NavDropdown.Item>
                </NavDropdown>
              </div>
              <div className="empty-sapce"></div>
              <div
                // onMouseEnter={() => onMouseEnter(2)}
                onMouseOver={() => onMouseEnter(2)}
                onMouseLeave={() => onMouseLeave(2)}
              >
                <NavDropdown
                  title="Tokens"
                  // menuVariant="dark"
                  className="dropdown"
                  show={dropdown1 ? true : false}
                >
                  <NavDropdown.Item
                    className="dropdown-content"
                    as={Link}
                    to="/contract/transactionList/ARC20"
                  >
                    ARC20 TransactionList
                  </NavDropdown.Item>
                  <NavDropdown.Divider></NavDropdown.Divider>
                  <NavDropdown.Item
                    className="dropdown-content"
                    as={Link}
                    to="/contract/transactionList/ARC721"
                  >
                    ARC721 TransactionList
                  </NavDropdown.Item>
                </NavDropdown>
              </div>
            </Nav>
          </Navbar>
        </div> */}
        <div className="network">
          <Dropdown />
          {/* {<img alt="더 보기" />} */}
        </div>
      </div>
    </header>
  );
};

const NavItem = (props) => {
  const activeStyle = {
    backgroundColor: "#000",
    color: "#fff",
  };

  return (
    <NavLink className="gnb-nav" to={props.link} activeStyle={activeStyle}>
      <span className="nav-text">{props.title}</span>
    </NavLink>
  );
};

NavItem.defaultProps = {
  link: "/",
  title: "navTitle",
};

export default Header;
